export enum SubscriptionTypeEnumDTO {
    BusinessUc = "BusinessUc",
    BusinessMp = "BusinessMp",
    Personal = "Personal",
    Social = "Social"
}
